import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ClientPage from "./pages/ClientPage";
import UsersPage from "./pages/UsersPage";
import AddLoanPage from "./pages/AddLoanPage";
import BandejaPage from "./pages/BandejaPage";
import AiPage from "./pages/AiPage";
import PortfolioPage from "./pages/PortfolioPage";
import LegalPage from "./pages/LegalPage";
import DrivePage from "./pages/DrivePage";

const FullLoader = () => (
  <div className="flex min-h-screen items-center justify-center" data-testid="app-loading">
    <Loader2 className="h-6 w-6 animate-spin text-[#0f5ef7]" />
  </div>
);

function Protected({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return children;
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <FullLoader />;
  return user ? <Navigate to="/" replace /> : children;
}

function HomeOrDashboard() {
  const { user, ready } = useAuth();
  if (!ready) return <FullLoader />;
  return user ? <DashboardPage /> : <LoginPage home />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/" element={<HomeOrDashboard />} />
            <Route path="/privacidad" element={<LegalPage page="privacidad" title="Aviso de privacidad" />} />
            <Route path="/terminos" element={<LegalPage page="terminos" title="Términos de uso" />} />
            <Route path="/clientes/:borrowerId" element={<Protected><ClientPage /></Protected>} />
            <Route path="/usuarios" element={<Protected><UsersPage /></Protected>} />
            <Route path="/creditos/nuevo" element={<Protected><AddLoanPage /></Protected>} />
            <Route path="/por-clasificar" element={<Protected><BandejaPage /></Protected>} />
            <Route path="/ia" element={<Protected><AiPage /></Protected>} />
            <Route path="/portfolio" element={<Protected><PortfolioPage /></Protected>} />
            <Route path="/google-drive" element={<Protected><DrivePage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
